import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExplicit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6798_4746)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: .75,
			y: .75,
			width: 14.5,
			height: 14.5,
			rx: 3.25,
			stroke: "currentColor",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5 3.5H11V4.76H6.51351V7.31857H10.5811V8.55286H6.51351V11.24H11V12.5H5V3.5Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6798_4746",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgExplicit;
